define("calendar/services/config", ["exports", "@ember/object/computed", "@ember/service", "@fullcalendar/core", "ember-concurrency-decorators", "@fullcalendar/daygrid", "@fullcalendar/list", "@fullcalendar/moment-timezone", "@fullcalendar/timegrid", "nprogress", "moment-timezone", "tracked-built-ins", "calendar/utils/fullcal-rightclick", "later/utils/constants"], function (_exports, _computed, _service, _core, _emberConcurrencyDecorators, _daygrid, _list, _momentTimezone, _timegrid, _nprogress, _momentTimezone2, _trackedBuiltIns, _fullcalRightclick, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  0; //eaimeta@70e063a35619d71f0,"@ember/object/computed",0,"@ember/service",0,"@fullcalendar/core",0,"ember-concurrency-decorators",0,"@fullcalendar/daygrid",0,"@fullcalendar/list",0,"@fullcalendar/moment-timezone",0,"@fullcalendar/timegrid",0,"nprogress",0,"moment-timezone",0,"tracked-built-ins",0,"calendar/utils/fullcal-rightclick",0,"later/utils/constants"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const {
    DEFAULT
  } = _constants.CALENDAR_TYPES;
  const {
    WEEK
  } = _constants.CALENDAR_VIEW_TYPES;
  let ConfigService = (_dec = (0, _computed.readOnly)('selectedSocialProfiles.hasMultipleSelected'), _dec2 = (0, _computed.readOnly)('selectedSocialProfiles.firstProfile'), (_class = class ConfigService extends _service.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "onboarding", _descriptor, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor2, this);

      _initializerDefineProperty(this, "userConfig", _descriptor3, this);

      _initializerDefineProperty(this, "startTime", _descriptor4, this);

      _initializerDefineProperty(this, "endTime", _descriptor5, this);

      _defineProperty(this, "calendarType", DEFAULT);

      _defineProperty(this, "fcView", WEEK);

      _defineProperty(this, "fullCalendar", null);

      _initializerDefineProperty(this, "multipleProfilesSelected", _descriptor6, this);

      _initializerDefineProperty(this, "singleSocialProfile", _descriptor7, this);
    }

    get timeZoneIdentifier() {
      var _this$userConfig$curr;

      return ((_this$userConfig$curr = this.userConfig.currentTimeZone) === null || _this$userConfig$curr === void 0 ? void 0 : _this$userConfig$curr.identifier) || '';
    }

    get calendarView() {
      return this.fcView;
    }

    set calendarView(value) {
      this.fcView = value;
    }

    get commonConfig() {
      return {
        allDaySlot: false,
        headerToolbar: this.headerToolbar,
        nowIndicator: true,
        // Note: Using patchedInteractionPlugin instead of interactionPlugin to support right-clicking
        plugins: [_daygrid.default, _timegrid.default, _list.default, _fullcalRightclick.default, _momentTimezone.default],
        progressiveEventRendering: true,
        scrollTime: '07:00:00',
        snapDuration: '00:05:00',
        timeZone: this.timeZoneIdentifier
      };
    }

    get headerToolbar() {
      // Note: Join is necessary here due to an issue with fullcalendar (https://stackoverflow.com/questions/64500933/fullcalendar-headertoolbar-button-displays-as-two-buttons)
      return {
        left: this.leftHeaders.join(' '),
        right: this.rightHeaders.join(' ')
      };
    }

    get leftHeaders() {
      const defaultCalendar = this.calendarType === DEFAULT;
      const defaultLeft = ['today,prev,next title'];
      const storiesLeft = ['today,prev,next title'];
      return defaultCalendar ? defaultLeft : storiesLeft;
    }

    get rightHeaders() {
      var _this$singleSocialPro;

      const defaultCalendar = this.calendarType === DEFAULT;
      const displayAdditionalButtons = ((_this$singleSocialPro = this.singleSocialProfile) === null || _this$singleSocialPro === void 0 ? void 0 : _this$singleSocialPro.isInstagram) && !this.multipleProfilesSelected;
      const socialProfileButtons = displayAdditionalButtons ? 'timezoneButton storiesButton previewButton,' : 'timezoneButton ';
      const defaultRight = ["".concat(socialProfileButtons, "timeGridWeek,dayGridMonth calendarSettings")];
      const storiesRight = ['timezoneButton storiesButton previewButton,weekButton,monthButton'];
      return defaultCalendar ? defaultRight : storiesRight;
    }

    handleLegacyDate(date) {
      const dateISO = Number(date);

      if (isNaN(dateISO)) {
        return new Date(date);
      }

      return new Date(dateISO);
    }

    *handleWithProgressBar(runTasks) {
      var _NProgress$configure;

      (_NProgress$configure = _nprogress.default.configure({
        parent: '.fc-view-harness'
      })) === null || _NProgress$configure === void 0 ? void 0 : _NProgress$configure.start();

      _nprogress.default.configure({
        parent: 'body'
      });

      yield runTasks();

      _nprogress.default.done();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "startTime", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "endTime", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "multipleProfilesSelected", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "singleSocialProfile", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleWithProgressBar", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "handleWithProgressBar"), _class.prototype)), _class));
  _exports.default = ConfigService;
});